import React from 'react';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';
import { SUPPORTED } from '@/i18n';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';

export function LanguageSwitcher({ compact = false, testid }) {
  const { i18n } = useTranslation();
  const current = SUPPORTED.find((s) => s.code === i18n.language) || SUPPORTED[0];

  const change = (code) => {
    i18n.changeLanguage(code);
    try { localStorage.setItem('lb_lang', code); } catch (e) { /* ignore */ }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid={testid || 'lang-switch'}
          className={`flex items-center gap-1.5 text-sm font-medium text-[#0D1B2A] hover:text-[#1677FF] transition-colors ${compact ? '' : ''}`}
        >
          <Globe className="w-4 h-4" /> {compact ? current.code.toUpperCase() : current.label}
          <svg className="w-3 h-3" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
          </svg>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {SUPPORTED.map((s) => (
          <DropdownMenuItem
            key={s.code}
            onSelect={() => change(s.code)}
            className={s.code === current.code ? 'font-semibold text-[#1677FF]' : ''}
          >
            {s.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
